import { TabPanel } from '@tencent/tea-component';
// tea内部会判断传入组件是否 === TabPanel  无法封装
export var BuyTabPanel = TabPanel;
//# sourceMappingURL=BuyTabPanel.js.map